export const karolinaWaligora = {
    'meta': {
        'title': 'Psychoterapeutka psychodynamiczna Karolina Waligóra',
        'description': 'Psychoterapeutka psychoanalityczna w trakcie czteroletniego szkolenia, pedagog, anglistka.'
    },
    'url': {
        'address': '/bydgoszcz/zespol/psychoterapeutka-karolina-waligora/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/karolina-waligora.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychoterapeuta w Bydgoszczy Karolina Waligóra'
        }
    }
}